// @ts-nocheck
import * as React from "react";
import { useEscapeKey } from "./useEscapeKey";

export function Modal({ open, title, onClose, children, footer, width = 520 }) {
  useEscapeKey(onClose, open);
  if (!open) return null;
  return (
    <div
      data-modal-backdrop="1"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(20,16,12,0.45)",
        display: "grid", placeItems: "center", zIndex: 100,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width, maxHeight: "85vh", overflow: "auto",
          background: "#fff", borderRadius: 14, boxShadow: "0 30px 80px rgba(0,0,0,.3)",
        }}
      >
        <div style={{ padding: "16px 22px", borderBottom: "1px solid var(--border-soft)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontWeight: 700, fontSize: 16 }}>{title}</div>
          <button onClick={onClose} className="btn btn-ghost btn-sm" style={{ padding: "4px 10px" }}>✕</button>
        </div>
        <div style={{ padding: 22 }}>{children}</div>
        {footer && <div style={{ padding: "14px 22px", borderTop: "1px solid var(--border-soft)", display: "flex", gap: 8, justifyContent: "flex-end" }}>{footer}</div>}
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label className="label">{label}</label>
      {children}
    </div>
  );
}
